// Implements: .claude/skills/rehaut-design/ui_kits/rehaut-pacientes/primitives.jsx (Expediente)
// See: .claude/skills/rehaut-design/HANDOFF.md
'use client';

/**
 * Expediente number rendered in Geist Mono with tabular numerals so
 * digits align across rows. Returns an em-dash placeholder when the
 * value is missing (pending patients without an assigned expediente).
 */
export function Expediente({ value }: { value: string | number | null | undefined }) {
  if (value === null || value === undefined || value === '') {
    return (
      <span
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: '11px',
          color: 'var(--ink-5)',
        }}
      >
        —
      </span>
    );
  }
  return (
    <span
      style={{
        fontFamily: 'var(--font-mono)',
        fontSize: '11px',
        color: 'var(--ink-3)',
        letterSpacing: '0.4px',
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {value}
    </span>
  );
}
